import React from 'react';
import T from 'prop-types';
import { get } from 'lodash-es';
import { getTransformedAccountDetails } from './getTransformedAccountDetails';
import { Translation } from 'srcAlias/client/locale';
import {
  Heading,
  Panel,
  Paragraph,
  Callout,
  PlaybackList,
  PlaybackKey,
  PlaybackValue,
} from '@piggybank/core';
import hooks from 'hooksAlias';
export const AccountNumberPanel = ({
  applicationDecisionData,
  selectedProduct,
}) => {
  const investmentAccountDetails = get(
    applicationDecisionData,
    'investmentAccounts',
    []
  );

  const transformedAccountDetails = getTransformedAccountDetails(
    investmentAccountDetails,
    selectedProduct
  );

  const formatAccountNumber = get(
    hooks,
    'validations.default.formatAccountNumber.formatAccountNumber',
    null
  );
  return (
    <>
      {transformedAccountDetails.map((item, key) => {
        if (item && !item.showAccountNumberPanel && item.showInformationPanel) {
          return (
            <div key={key}>
              <Callout type="warning">
                <Paragraph marginBottom={1}>
                  <Translation path={item.calloutWarningText} />
                </Paragraph>
              </Callout>
            </div>
          );
        }
        return null;
      })}
      <Panel>
        <Heading level={2} marginBottom={3}>
          <Translation path={'headingAccountPanel'} />
        </Heading>

        {transformedAccountDetails.map((item, key) => {
          if (
            item &&
            item.showAccountNumberPanel &&
            !item.showInformationPanel
          ) {
            return (
              <div key={key}>
                <PlaybackList marginBottom={3}>
                  <PlaybackKey>
                    <Translation path={item.accountNumberPanelLabel} />
                  </PlaybackKey>
                  <PlaybackValue marginBottom>
                    {formatAccountNumber
                      ? formatAccountNumber(
                          get(item, 'investmentAccountIdentifier', '')
                        )
                      : get(item, 'investmentAccountIdentifier', '')}
                  </PlaybackValue>
                </PlaybackList>
              </div>
            );
          }
          return null;
        })}
      </Panel>
    </>
  );
};

AccountNumberPanel.propTypes = {
  applicationDecisionData: T.object,
  selectedProduct: T.object,
};

export default AccountNumberPanel;
